import { notify } from "@/components/common/Notification";
import { AxiosRequestConfig, AxiosResponse } from "axios";
import { axiosConfig } from "./axiosConfig";

export interface ApiError {
  message: string;
  status: number;
  errors?: any;
}

export interface RequestConfig extends AxiosRequestConfig {
  showNotification?: boolean;
  customErrorMessage?: string;
  notifyMessage?: boolean; // default: false
}

export const get = async <T = any>(
  url: string,
  config?: RequestConfig
): Promise<T> => {
  try {
    const response: AxiosResponse<T> = await axiosConfig.get(url, config);
    return response.data;
  } catch (error: any) {
    handelError(error);
    return undefined as T;
  }
};

export const post = async <T = any, D = any>(
  url: string,
  data?: D,
  config?: RequestConfig
): Promise<T> => {
  try {
    const response: AxiosResponse<T> = await axiosConfig.post(
      url,
      data,
      config
    );
    return response.data;
  } catch (error: any) {
    handelError(error);
    return undefined as T;
  }
};

export const put = async <T = any, D = any>(
  url: string,
  data?: D,
  config?: RequestConfig
): Promise<T> => {
  try {
    const response: AxiosResponse<T> = await axiosConfig.put(url, data, config);
    return response.data;
  } catch (error: any) {
    handelError(error);
    return undefined as T;
  }
};

export const patch = async <T = any, D = any>(
  url: string,
  data?: D,
  config?: RequestConfig
): Promise<T> => {
  try {
    const response: AxiosResponse<T> = await axiosConfig.patch(
      url,
      data,
      config
    );
    return response.data;
  } catch (error: any) {
    handelError(error);
    return undefined as T;
  }
};

export const del = async <T = any>(
  url: string,
  config?: RequestConfig
): Promise<T> => {
  try {
    const response: AxiosResponse<T> = await axiosConfig.delete(url, config);
    return response.data;
  } catch (error: any) {
    handelError(error);
    return undefined as T;
  }
};

const handelError = (error: any) => {
  if (
    error.code === "ERR_NETWORK" ||
    error.message?.includes("Network Error")
  ) {
    notify.error(
      "Network Error",
      "Unable to connect to the server. Please check your internet connection."
    );
  }

  // const { status, data } = error.response;
  // const errorMessage =
  //   data?.error?.message ??
  //   data?.message ??
  //   data?.error ??
  //   data?.non_field_errors ??
  //   "An error occurred";
  //   const errorCode = data?.error?.code ?? status;
  //   notify.error(errorCode, errorMessage);
};
